'use client';

import { cx } from '@onbeam/business-styled-system/css';
import { center, text } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { ShaderBannerProps } from './ShaderBanner.types';
import { ShaderBannerAnimation } from './ShaderBannerAnimation';
import NextLink from 'next/link';
import { useRef } from 'react';
import { useInView } from 'motion/react';

export const ShaderBanner = ({
  title,
  description,
  button: { href, text: buttonText, isExternal },
  className,
  preset,
}: ShaderBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    margin: '500px 0px 500px 0px',
  });

  return (
    <div
      ref={ref}
      className={cx(
        'light',
        center({
          flexDirection: 'column',
          position: 'relative',
          w: 'full',
          h: '[32.5rem]',
          rounded: 'md',
          textAlign: 'center',
          overflow: 'hidden',
          color: 'mono.primaryFg',
          gap: '6',
          p: '5',
          md: {
            h: '[28.75rem]',
          },
        }),
        className,
      )}
    >
      {isInView && <ShaderBannerAnimation preset={preset} />}
      <h2 className={text({ style: 'subtitle-lg' })}>{title}</h2>
      {description && (
        <p className={text({ style: 'body-lg', maxW: '[27.5rem]' })}>
          {description}
        </p>
      )}
      <Button
        as={NextLink}
        href={href}
        target={isExternal ? '_blank' : '_self'}
        rel="noopener noreferrer"
        variant="secondary"
      >
        {buttonText}
      </Button>
    </div>
  );
};
